/**
 * * Promisified listener
 *
 * @description
 * This function returns a promise which resolves when the event is triggered.
 *
 * @example
 * ```ts
 * const element = document.getElementById('element');
 * promisifiedListener('click', element).then(() => console.log('clicked'));
 *
 * ```
 */
export const promisifiedDOMListener = (
  eventName: keyof WindowEventMap | keyof HTMLElementEventMap,
  target: Window | HTMLElement = window,
  $window: Window = window,
) =>
  new Promise<Event>((resolve) => {
    const listener = (e: Event) => {
      target.removeEventListener(eventName, listener as EventListener);
      resolve(e);
    };
    target.addEventListener(eventName, listener as EventListener);
    /**
     * All the listeners should be removed when the page is hidden
     * to prevent memory leaks and unexpected behavior.
     *
     * For example, if the user navigates back to the previous page,
     * promise could be not resolved and the listener could be still active
     * for SPA cases (Not Available page and etc.)
     */
    $window.addEventListener('pagehide', listener as EventListener);
  });
